/**
 * Created by hl on 2018/12/14.
 */
const appBaseUrl = 'openanjuke://jump';
const downloadConfig = {
  site: {
    appInfo: {
      iosUrl: 'https://itunes.apple.com/cn/app/id415606289',
      iosHighUrl: 'https://mlink.anjuke.com/?', // IOS系统>=9时用的新下载链接
      androidUrl: '//android.anjuke.com/getapkx.php?app=Anjuke&',
      apm: 'b318',
      version: '11.8.2',
      action: 'download',
      weixinUrl: '//a.app.qq.com/o/simple.jsp?pkgname=com.anjuke.android.app&g_f=991653&ipm=touch',
      harmonyLink: 'store://appgallery.huawei.com/app/detail?id=com.anjuke.home',
      homeLink: `${appBaseUrl}/app/main_tab_page`,
      loupanLink: `${appBaseUrl}/newhouse/building_detail`,
      loupanlistLink: `${appBaseUrl}/newhouse/building_list`,
      housetypeLink: `${appBaseUrl}/newhouse/housetype_detail`,
    },
  },
};
export default downloadConfig;
